import CottonXl from '../assets/images/Cotton-XL.svg'
import CottonXXl from '../assets/images/Cotton-XXL.svg'
import Herbal20 from '../assets/images/Herbal-20pad.png'
import HerbalXl from '../assets/images/Herbal-XL.svg'
import HerbalXXl from '../assets/images/Herbal-XXL.svg'
import combo20 from '../assets/images/combo-20 pad.png'
import combo20Two from '../assets/images/cotton-20pad.png'

export const introSlider = {
    nav: false,
    dots: true,
    loop: false,
    items: 1,
    autoplay: false
}


export const products = [
    {
        name: 'Sanitary Napkin | Cotton',
        description: `Sanitary napkins made from cotton offer comfort, absorbency, and environmental sustainability. Cotton's softness and breathability provide a gentle experience while ensuring efficient absorption. These napkins are hypoallergenic and suitable for sensitive skin. Additionally, their biodegradable nature reduces environmental impact compared to synthetic options, making them a sustainable choice for menstrual hygiene.`,
        products: [
            {
                image: CottonXl,
                padPack: 12 + " Pad | Pack",
                strikePrice: 400,
                salePrice: 250,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZXlhTkKjdL"
            },
            {
                image: CottonXXl,
                padPack: 12 + " Pad | Pack",
                strikePrice: 429,
                salePrice: 280,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZY0Apo48Sq"
            },
            {
                image: combo20Two,
                padPack: 20 + " Pad | Pack",
                strikePrice: 580,
                salePrice: 480,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZYELmuMedt"
            }
        ],
    },
    {
        name: 'Sanitary Napkin | Herbal',
        description: `Herbal sanitary napkins incorporate natural ingredients like Aloe vera, Neem and Vettiveru, known for their soothing and therapeutic properties. These napkins offer comfort, hygiene, and freshness during menstruation, addressing concerns such as irritation, odor, and discomfort. By utilizing herbal extracts, they provide a natural and gentle alternative to conventional pads, promoting overall well-being and confidence.`,
        products: [
            {
                image: HerbalXl,
                padPack: 12 + " Pad | Pack",
                strikePrice: 429,
                salePrice: 280,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZXW1g9p95Y"
            },
            {
                image: HerbalXXl,
                padPack: 12 + " Pad | Pack",
                strikePrice: 449,
                salePrice: 300,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZXHm4CHTif"
            },
            {
                image: combo20,
                padPack: 20 + " Pad | Pack",
                strikePrice: 595,
                salePrice: 495,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZYbnYQ0Q5m"
            },

            {
                image: Herbal20,
                padPack: 20 + " Pad | Combo",
                strikePrice: 590,
                salePrice: 490,
                url: "https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/li_QpP9ZYQGMzB2s5"
            },
        ],
    }
]

export const testimonials = [
    {
        "name": "Sruthi",
        "content": "Herbal napkins are very comfortable and it's good for our body and environment",
        "designation": "Customer",
        "image": require('../assets/testimonials/01.jpg')
    },
    {
        "name": "Dhivya Pazhani",
        "content": "I use this bio sanitary napkin recent times it was very nice and more comfortable also it was fully made on natural products so it is good for ur health too.along with napkin disposable bag also provided therefore it was easy to dispose after use.",
        "designation": "Customer",
        "image": require('../assets/testimonials/02.jpg')
    },
    {
        "name": "Indhu G R",
        "content": "I have used Fefine organic sanitary napkins for the past few months and I like the quality of the product they are soft, gentle, rash-free and perfect for the skin. This napkin has good absorbency and is made with eco-friendly, chemical-free materials which is very comfortable for the skin. A great choice for comfort and sustainability!",
        "designation": "Customer",
        "image": require('../assets/testimonials/03.jpg')
    },
    {
        "name": "Sivagami Sivagami",
        "content": "I really appreciated the quality of the napkin. It was soft yet durable, and it held up well during use. The design was also lovely and added a nice touch to the meal. Overall, I was very satisfied!",
        "designation": "Customer",
        "image": require('../assets/testimonials/04.jpg')
    },
    {
        "name": "Rage Ramya",
        "content": "I just loving this product... Really I suggest every women to use this product for you comfortness..... Must use product.....try use this chemical free napkin for your goodness",
        "designation": "Customer",
        "image": require('../assets/testimonials/05.jpg')
    },
    {
        "name": "Kalpana Janakiraman",
        "content": "Recently purchased fefine bio sanitary napkins is very good for our skin without rashes felt super soft and comfortable... compared to other bio sanitary pads this one sticks well and packaging also good with disposable covers...will recommend everyone to buy this... & Happy buying",
        "designation": "Customer",
        "image": require('../assets/testimonials/06.jpg')
    },
    {
        "name": "Sathya Priya",
        "content": "Awesome product that is incrediblely comfortable to use and makes you feel protected and secure. Everyone should give it a try…",
        "designation": "Customer",
        "image": require('../assets/testimonials/07.jpg')
    },
    {
        "name": "Sashvikha V Sivagami Selvi",
        "content": "I am using this product and I love the eco-friendly initiative! Finally, a sustainable solution for menstrual hygiene. Thank you for creating these amazing napkins. I feel very smooth no itching. It's so comfortable long lasting and quick absorbent. Providing Disposable covers are very useful and good Idea.",
        "designation": "Customer",
        "image": require('../assets/testimonials/08.jpg')
    },
]